/**
 * SalesProposalsPage — Phase 33.9.
 *
 * Placeholder page for the proposals list. No list endpoint exists until
 * Phase 34. Directs the user to view proposals from lead detail pages.
 */

import { Navigate, Link } from 'react-router-dom';
import { isOmegaAdmin } from '@/features/omega/adminMode';
import { Breadcrumbs } from '@/features/omega/Breadcrumbs';

// ── Constants ────────────────────────────────────────────────────────────────

const PROPOSAL_STATUS_COLORS: Record<string, string> = {
  draft:    '#7dd3fc',
  sent:     '#a78bfa',
  approved: '#6ee7b7',
  rejected: '#f87171',
  expired:  '#fbbf24',
};

// ── Helpers ──────────────────────────────────────────────────────────────────

export function proposalStatusColor(s: string): string {
  return PROPOSAL_STATUS_COLORS[s] ?? 'var(--omega-ink-subtle)';
}

// ── Page ─────────────────────────────────────────────────────────────────────

export function SalesProposalsPage() {
  if (!isOmegaAdmin()) return <Navigate to="/" replace />;

  return (
    <div
      className="omega-shell"
      style={{ fontFamily: 'var(--omega-mono)', color: 'var(--omega-ink)', padding: '16px 20px' }}
    >
      <Breadcrumbs
        crumbs={[
          { label: 'OMEGA', to: '/omega' },
          { label: 'Sales', to: '/omega/sales' },
          { label: 'Proposals' },
        ]}
      />

      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20, marginTop: 8 }}>
        <h1 style={{ margin: 0, fontSize: '11pt', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase' }}>
          Proposals
        </h1>
      </div>

      <div
        style={{
          background: 'rgba(255,255,255,0.03)',
          border: '1px solid rgba(255,255,255,0.08)',
          borderRadius: 6,
          padding: '28px 24px',
          maxWidth: 560,
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          alignItems: 'flex-start',
        }}
      >
        <div
          style={{
            fontSize: '8.5pt',
            color: 'var(--omega-ink-subtle)',
            lineHeight: 1.7,
          }}
        >
          Proposal list available in Phase 34. View proposals by navigating to a lead's detail page.
        </div>

        <Link
          to="/omega/sales/leads"
          style={{
            fontFamily: 'var(--omega-mono)',
            fontSize: '9pt',
            fontWeight: 600,
            background: 'rgba(125,211,252,0.1)',
            border: '1px solid rgba(125,211,252,0.3)',
            borderRadius: 4,
            color: '#7dd3fc',
            padding: '7px 16px',
            textDecoration: 'none',
            display: 'inline-block',
          }}
        >
          Go to Leads
        </Link>
      </div>
    </div>
  );
}
